import PropTypes from 'prop-types'
import { useFormikContext } from 'formik'
import { isEmpty } from 'lodash'

const CustomErrorMessage = ({ name, showValidationErrors, info }) => {
  const { errors } = useFormikContext()

  return isEmpty(info) ? (
    <>
      {!isEmpty(errors[name]) && showValidationErrors ? (
        <div className="error-message">{errors[name]}</div>
      ) : null}
    </>
  ) : (
    <div className="error-message">{info}</div>
  )
}

CustomErrorMessage.defaultProps = {
  name: '',
  showValidationErrors: false,
  info: '',
}
CustomErrorMessage.propTypes = {
  name: PropTypes.string,
  showValidationErrors: PropTypes.bool,
  info: PropTypes.string,
}

export default CustomErrorMessage
